module.exports = __webpack_public_path__ + "img/avatar2.8e1e7294.png";